function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableproperties/commands/tablepropertycommand
 */
import { Command } from 'ckeditor5/src/core';
/**
 * The table cell attribute command.
 *
 * This command is a base command for other table property commands.
 *
 * @extends module:core/command~Command
 */

var TablePropertyCommand = /*#__PURE__*/function (_Command) {
  _inherits(TablePropertyCommand, _Command);

  var _super = _createSuper(TablePropertyCommand);

  /**
   * Creates a new `TablePropertyCommand` instance.
   *
   * @param {module:core/editor/editor~Editor} editor An editor in which this command will be used.
   * @param {String} attributeName Table cell attribute name.
   * @param {String} defaultValue The default value of the attribute.
   */
  function TablePropertyCommand(editor, attributeName, defaultValue) {
    var _this;

    _classCallCheck(this, TablePropertyCommand);

    _this = _super.call(this, editor);
    /**
     * The attribute that will be set by the command.
     *
     * @readonly
     * @member {String}
     */

    _this.attributeName = attributeName;
    /**
     * The default value for the attribute.
     *
     * @readonly
     * @protected
     * @member {String}
     */

    _this._defaultValue = defaultValue;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(TablePropertyCommand, [{
    key: "refresh",
    value: function refresh() {
      var editor = this.editor;
      var selection = editor.model.document.selection;
      var table = selection.getFirstPosition().findAncestor('table');
      this.isEnabled = !!table;
      this.value = this._getValue(table);
    }
    /**
     * Executes the command.
     *
     * @fires execute
     * @param {Object} [options]
     * @param {*} [options.value] If set, the command will set the attribute on the selected table.
     * If not set, the command will remove the attribute from the selected table.
     * @param {module:engine/model/batch~Batch} [options.batch] Pass the model batch instance to the command to aggregate changes,
     * for example, to allow a single undo step for multiple executions.
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var selection = model.document.selection;
      var value = options.value,
          batch = options.batch;
      var table = selection.getFirstPosition().findAncestor('table');

      var valueToSet = this._getValueToSet(value);

      model.enqueueChange(batch || 'default', function (writer) {
        if (valueToSet) {
          writer.setAttribute(_this2.attributeName, valueToSet, table);
        } else {
          writer.removeAttribute(_this2.attributeName, table);
        }
      });
    }
    /**
     * Returns the attribute value for a table.
     *
     * @param {module:engine/model/element~Element} table
     * @returns {String|undefined}
     * @private
     */

  }, {
    key: "_getValue",
    value: function _getValue(table) {
      if (!table) {
        return;
      }

      var value = table.getAttribute(this.attributeName);

      if (value === this._defaultValue) {
        return;
      }

      return value;
    }
    /**
     * Returns the proper model value. It can be used to add a default unit to numeric values.
     *
     * @private
     * @param {*} value
     * @returns {*}
     */

  }, {
    key: "_getValueToSet",
    value: function _getValueToSet(value) {
      if (value === this._defaultValue) {
        return;
      }

      return value;
    }
  }]);

  return TablePropertyCommand;
}(Command);

export { TablePropertyCommand as default };